import { Api } from '@pbk-web/data';

export default class BaseService extends Api {}
